import { render } from "./HeroiconsSolidChartPie.vue?vue&type=template&id=4e1ce3d7"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChartPie.vue"]])

export default __exports__